"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const context_1 = require("components/context");
const menu_1 = __importDefault(require("services/menu"));
const useMenu = () => {
    const [menu, setMenu] = (0, react_1.useState)();
    const authContext = (0, react_1.useContext)(context_1.AuthContext);
    (0, react_1.useEffect)(() => {
        const onSuccess = (response) => {
            //configuramos los items de tipo padre
            const items = response?.data;
            setMenu(items);
        };
        const onFailSessionExpired = () => {
            authContext?.signOut?.();
        };
        (0, menu_1.default)({
            params: {
                data: {
                    uid: authContext?.loginData?.uid,
                    uidtipo: authContext?.loginData?.uidtipo,
                },
            },
            callback: {
                onSuccess,
                onFailSessionExpired,
            },
        });
    }, []);
    return [menu, setMenu];
};
exports.default = useMenu;
